/**
 * Envolve um callback de polling para que ele só rode com a aba em primeiro
 * plano. Aba em segundo plano não é vista por ninguém — o request é desperdício
 * de banda no cliente e de CPU no backend.
 *
 * O timer segue armado: assim que a aba volta a ficar visível o próximo tick
 * já executa normalmente, sem precisar de listener de `visibilitychange`.
 *
 * Uso: `setInterval(whenVisible(fetchStatus), 3000)`
 */
export const whenVisible =
  (fn: () => void) =>
    () => {
      if (typeof document === 'undefined' || document.visibilityState === 'visible') {
        fn();
      }
    };
